var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "generalInfo" },
    [
      _c("div", { class: [{ row: _vm.showUpdatorInfo }] }, [
        _c(
          "div",
          {
            staticClass: "generalInfo_left",
            class: [
              { "small-6 medium-6 large-6 columns": _vm.showUpdatorInfo },
            ],
          },
          [
            !_vm.isEdit && _vm.showPersonIncharge
              ? [
                  _vm.isWaitingApprove
                    ? _c("i", { staticClass: "gray_font" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("workPermit.waitingApproveBy", [
                                _vm.personIncharge,
                              ])
                            ) +
                            "\n        "
                        ),
                      ])
                    : _c("i", { staticClass: "gray_font" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("workPermit.underReviewBy", [
                                _vm.personIncharge,
                              ])
                            ) +
                            "\n        "
                        ),
                      ]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              !_vm.isEdit && _vm.hasSubmitInfo
                ? _c("i", { staticClass: "gray_font" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("workPermit.submitHint", [
                            _vm.submitInfo.name,
                            _vm.submitInfo.time,
                          ])
                        ) +
                        "\n        "
                    ),
                  ])
                : _vm._e(),
            ]),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: [
              "generalInfo_right",
              { "small-6 medium-6 large-6 columns": _vm.showUpdatorInfo },
            ],
          },
          [
            _vm.isProjectAvailable
              ? _c(
                  "div",
                  {
                    staticClass: "suspend-resume-extend-btns",
                    class: [{ "top-right-buttons": !_vm.showUpdatorInfo }],
                  },
                  [
                    _vm.canApprovePP ||
                    _vm.canApproveWP ||
                    _vm.showEditBtn ||
                    _vm.showExportBtn
                      ? _c(
                          "div",
                          { staticClass: "btns-group" },
                          [
                            _c(
                              "HKLViewLayout",
                              { attrs: { checkIsHKL: true } },
                              [
                                _vm.showExportBtn
                                  ? _c(
                                      "HKLButton",
                                      {
                                        attrs: { color: "orange" },
                                        on: { click: _vm.generateNotice },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t(
                                                "settings.security.workPermit.generateNotice"
                                              )
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.showEditBtn && !_vm.isEdit
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn--darkblue",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.goToCreate()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("action.edit")) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showSuspendBtn
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn--darkblue",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openSuspendModal()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("action.suspend")) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showResumeBtn
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn--orange",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openResumeModal()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("action.resume")) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showExtBtn
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn--orange",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openExtendModal()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("action.extend")) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showExtensionBtns
                              ? [
                                  _c("HKLButton", {
                                    attrs: {
                                      color: "darkblue",
                                      action: "rejectExtension",
                                    },
                                    on: { click: _vm.openRejectExtensionModal },
                                  }),
                                  _vm._v(" "),
                                  _c("HKLButton", {
                                    attrs: {
                                      color: "orange",
                                      action: "confirmExtension",
                                    },
                                    on: { click: _vm.openConfirmExtendModal },
                                  }),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "btns-group" }, [
                      _vm.showReassignBtn
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn--orange",
                              on: {
                                click: function ($event) {
                                  return _vm.openReAssignModal()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("action.reAssign")) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showRequestBtn
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn--orange",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.openRequestExtendModal()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("action.requestExtension")) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "general-info-main" },
        [
          _c(
            "div",
            { staticClass: "general-info-basic-left" },
            [
              _vm.isStandalone && _vm.currentWorkPermit.isTenantProject
                ? _c("div", { staticClass: "general-info__tenantTradeName" }, [
                    _c("p", { staticClass: "bold" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("user.tenantName")) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.companyName))]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "generalInfo_contractorName new-multiselect" },
                [
                  _c(
                    "p",
                    {
                      class: [
                        "bold",
                        { "required-flag": _vm.isContractorEditable },
                      ],
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("workPermit.contractorName")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isContractorEditable
                    ? _c("HKLSelect", {
                        directives: [
                          { name: "hkldinput", rawName: "v-hkldinput" },
                        ],
                        class: {
                          "small-6 medium-6 large-6 columns":
                            !_vm.showUpdatorInfo,
                          "error-highlight": !_vm.validContractor,
                          "general-info-contractor-select": true,
                        },
                        attrs: {
                          value: _vm.contractorSelectValue,
                          options: _vm.companyHklOptions,
                          showSearch: true,
                          singleTaggableInput: true,
                          placeholder: "",
                        },
                        on: {
                          search: _vm.onContractorSearch,
                          input: _vm.onContractorInput,
                          change: _vm.updateContractor,
                        },
                      })
                    : _c("p", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              (_vm.contractorInfo && _vm.contractorInfo.name) ||
                                _vm.$t("emptyValue")
                            ) +
                            "\n        "
                        ),
                      ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isStandalone && _vm.isTenantProject
                ? _c("StandaloneContacts", { attrs: { isEdit: _vm.isEdit } })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "general-info__time" }, [
                _c("div", { staticClass: "generalInfo_duration" }, [
                  _c(
                    "p",
                    { class: ["bold", { "required-flag": _vm.isEdit }] },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("workPermit.durationOfWork")) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isEdit
                    ? _c("i", { staticClass: "gray_font" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("workPermit.plsInputWorkPeriod")) +
                            "\n          "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "generalInfo_timePicker" },
                    [
                      _vm.isEdit
                        ? _c("DateTimeSelector", {
                            key: _vm.timestamp + "_generalInfo_startDate",
                            attrs: {
                              date:
                                _vm.currentWorkPermit &&
                                _vm.currentWorkPermit.startDate,
                              showClearBtn: true,
                              setMinTime: true,
                              disabledDates: _vm.disabledDates,
                              highlightClass: _vm.checkIfInvalidClassByDate(
                                _vm.validStartDate
                              ),
                              required: true,
                              dirtyCheck: true,
                            },
                            on: {
                              updateDate: function (val) {
                                return _vm.updateField("startDate", val)
                              },
                            },
                          })
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.formatDate(
                                  _vm.currentWorkPermit &&
                                    _vm.currentWorkPermit.startDate,
                                  true
                                )
                              )
                            ),
                          ]),
                      _vm._v(" "),
                      _vm.isEdit
                        ? _c(
                            "span",
                            { staticClass: "generalInfo_timePickerTo" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("dateTo")) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _c("span", [_vm._v("-")]),
                      _vm._v(" "),
                      _vm.isEdit
                        ? _c("DateTimeSelector", {
                            key: _vm.timestamp + "_generalInfo_endDate",
                            attrs: {
                              date: _vm.currentWorkPermit.endDate,
                              showClearBtn: true,
                              setMinTime: true,
                              required: true,
                              highlightClass: _vm.checkIfInvalidClassByDate(
                                _vm.validEndDate
                              ),
                              disabledDates: _vm.disabledDates,
                              dirtyCheck: true,
                            },
                            on: {
                              updateDate: function (val) {
                                return _vm.updateField("endDate", val)
                              },
                            },
                          })
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.formatDate(
                                  _vm.currentWorkPermit &&
                                    _vm.currentWorkPermit.endDate,
                                  true
                                )
                              )
                            ),
                          ]),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm.currentWorkPermit.extendDate
                  ? _c("div", [
                      _c("p", { staticClass: "bold" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("workPermit.originalDate")) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "generalInfo_timePicker" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.formatDate(
                                _vm.currentWorkPermit.extendDate,
                                true
                              )
                            )
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentWorkPermit.requestExtendDate
                  ? _c("div", { staticClass: "yellow_font" }, [
                      _c("div", [_c("span", [_vm._v(_vm._s(_vm.extendText))])]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "generalInfo_building" },
                [
                  _c(
                    "p",
                    {
                      class: [
                        "bold",
                        { "required-flag": !_vm.isTenantProject && _vm.isEdit },
                      ],
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("workPermit.building")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.isTenantProject && _vm.isEdit
                    ? _c("HKLSelect", {
                        class: {
                          "small-6 medium-6 large-6 columns":
                            !_vm.showUpdatorInfo,
                          "error-highlight": !_vm.validBuilding,
                        },
                        attrs: {
                          value: _vm.selectedBuildingCode || undefined,
                          options: _vm.buildingHklOptions,
                          showSearch: true,
                          placeholder: "",
                        },
                        on: { change: _vm.onBuildingHklChange },
                      })
                    : _c("p", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.selectedBuilding.fullName || "--") +
                            "\n        "
                        ),
                      ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "generalInfo_floor new-multiselect" },
                [
                  _c(
                    "p",
                    { class: ["bold", { "required-flag": _vm.isEdit }] },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("workPermit.floor")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isEdit
                    ? _c("i", { staticClass: "gray_font" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("workPermit.plsInputInvolvedFloors")
                            ) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEdit
                    ? _c("HKLMultiSelect", {
                        class: {
                          "small-6 medium-6 large-6 columns":
                            !_vm.showUpdatorInfo,
                          "error-highlight": !_vm.validFloor,
                          "general-info-floor-select": true,
                        },
                        attrs: {
                          value: _vm.selectedFloorLabels,
                          options: _vm.floorsHklOptions,
                          respectOptionDisabled:
                            _vm.disableProtectedFloorRemoval,
                          showSearch: true,
                          dropdownClassName: "general-info-floor-dropdown",
                          placeholder: "",
                        },
                        on: { change: _vm.onFloorsHklChange },
                      })
                    : _c("p", [
                        _vm._v(
                          "\n          " + _vm._s(_vm.getFloor()) + "\n        "
                        ),
                      ]),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.currentWorkPermit.isTenantProject
                ? _c("div", { staticClass: "generalInfo_location" }, [
                    _c(
                      "p",
                      { class: ["bold", { "required-flag": _vm.isEdit }] },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("workPermit.location")) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isEdit
                      ? _c(
                          "div",
                          {
                            class: [
                              {
                                "small-6 medium-6 large-6 columns":
                                  !_vm.showUpdatorInfo,
                              },
                            ],
                          },
                          [
                            _c("TextField", {
                              attrs: {
                                required:
                                  _vm.isEdit &&
                                  !_vm.currentWorkPermit.isTenantProject,
                                value: _vm.currentWorkPermit.location,
                              },
                              on: {
                                updateValue: function (val) {
                                  return _vm.updateLocation(val)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _c("p", [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.locationValue) +
                              "\n        "
                          ),
                        ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.currentWorkPermit.isTenantProject &&
              _vm.currentWorkPermit.standalone
                ? _c(
                    "div",
                    { staticClass: "generalInfo_premises small-6 columns" },
                    [
                      _c("label", { staticClass: "wp-premises-label" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("tenancy.premises")) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.isEdit
                        ? _c(
                            "div",
                            { staticClass: "wp-premises-edit" },
                            [
                              _c("HKLInput", {
                                staticClass: "wp-premises-input",
                                attrs: {
                                  value: _vm.currentWorkPermit.wpPremises,
                                  placeholder: _vm.$t(
                                    "tender.general.premisesHint"
                                  ),
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.updateSAPremises(
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _c("p", [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.SAPremisesValue) +
                                "\n        "
                            ),
                          ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "generalInfo_descriptionOfWork" },
                [
                  _c(
                    "p",
                    {
                      class: [
                        "bold",
                        {
                          "edit-label": _vm.isEdit,
                          "required-flag": _vm.isEdit,
                        },
                      ],
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("workPermit.descriptionOfWork")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isEdit
                    ? _c("HKLSelect", {
                        class: {
                          "small-6 medium-6 large-6 columns":
                            !_vm.showUpdatorInfo,
                          "error-highlight": !_vm.validWorkType,
                        },
                        attrs: {
                          value: _vm.currentWorkPermit.workType || undefined,
                          options: _vm.workTypeHklOptions,
                          showSearch: true,
                          placeholder: "",
                        },
                        on: {
                          change: function (val) {
                            return _vm.updateField("workType", val)
                          },
                        },
                      })
                    : _c("p", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.currentWorkPermit.workType) +
                            "\n        "
                        ),
                      ]),
                  _vm._v(" "),
                  _vm.isTelecom
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "generalInfo_telecom small-6 medium-6 large-6",
                          class: { readonly: !_vm.isEdit },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c("InputField", {
                                staticClass:
                                  "generalInfo_telecom-item small-12 medium-4 large-4",
                                attrs: {
                                  label: _vm.$t(
                                    "workPermit.telecom.TBC_MDFRoom"
                                  ),
                                  showFlag: _vm.isEdit,
                                  showColon: false,
                                  required: true,
                                  readonly: !_vm.isEdit,
                                  value:
                                    _vm.currentWorkPermit.telecomTbcNbfRoom,
                                },
                                on: {
                                  updateValue: function (val) {
                                    return _vm.updateField(
                                      "telecomTbcNbfRoom",
                                      val
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("InputField", {
                                staticClass:
                                  "generalInfo_telecom-item small-12 medium-4 large-4",
                                attrs: {
                                  label: _vm.$t("workPermit.telecom.telDuct"),
                                  showFlag: _vm.isEdit,
                                  showColon: false,
                                  required: true,
                                  readonly: !_vm.isEdit,
                                  value: _vm.currentWorkPermit.telecomTelDuct,
                                },
                                on: {
                                  updateValue: function (val) {
                                    return _vm.updateField(
                                      "telecomTelDuct",
                                      val
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("InputField", {
                                staticClass:
                                  "generalInfo_telecom-item small-12 medium-4 large-4",
                                attrs: {
                                  label: _vm.$t(
                                    "workPermit.telecom.otherLocations"
                                  ),
                                  showFlag: false,
                                  showColon: false,
                                  required: false,
                                  readonly: !_vm.isEdit,
                                  value:
                                    _vm.currentWorkPermit.telecomOtherLocations,
                                },
                                on: {
                                  updateValue: function (val) {
                                    return _vm.updateField(
                                      "telecomOtherLocations",
                                      val
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.isOthers || _vm.isEvent) && _vm.isEdit
                    ? _c("div", [
                        _c("i", { class: ["gray_font", "required-flag"] }, [
                          _vm._v(
                            _vm._s(
                              _vm.isEvent
                                ? _vm.$t(
                                    "workPermit.descriptionEventRequireHint"
                                  )
                                : _vm.$t("workPermit.descriptionRequireHint")
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: {
                        "small-6 medium-6 large-6 columns":
                          !_vm.showUpdatorInfo,
                      },
                    },
                    [
                      _c("TextField", {
                        directives: [
                          { name: "hkldinput", rawName: "v-hkldinput" },
                        ],
                        attrs: {
                          readonly: !_vm.isEdit,
                          required: _vm.isOthers || _vm.isEvent,
                          value: _vm.currentWorkPermit.description,
                        },
                        on: {
                          updateValue: function (val) {
                            return _vm.updateField("description", val)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isEdit || _vm.noisyWorkingHoursChecked
                ? _c("div", { staticClass: "generalInfo_noisyWorkingHours" }, [
                    _c(
                      "div",
                      { staticClass: "emphasis noisyWorkingHour-section" },
                      [
                        _vm.isEdit
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.noisyWorkingHoursChecked,
                                  expression: "noisyWorkingHoursChecked",
                                },
                                { name: "hkldinput", rawName: "v-hkldinput" },
                              ],
                              staticClass: "general-checkbox",
                              attrs: {
                                id: "workPermit.noisyWorkingHours",
                                type: "checkbox",
                                name: "noisyWorkingHours",
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.noisyWorkingHoursChecked
                                )
                                  ? _vm._i(_vm.noisyWorkingHoursChecked, null) >
                                    -1
                                  : _vm.noisyWorkingHoursChecked,
                              },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$a = _vm.noisyWorkingHoursChecked,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.noisyWorkingHoursChecked =
                                            $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.noisyWorkingHoursChecked = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.noisyWorkingHoursChecked = $$c
                                    }
                                  },
                                  function (event) {
                                    return _vm.onNoisyWorkingHourChecked(event)
                                  },
                                ],
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "bold",
                            attrs: { for: "workPermit.noisyWorkingHours" },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("workPermit.noisyWorkingHours")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.noisyWorkingHoursChecked
                      ? _c(
                          "div",
                          { class: { "large-5": !_vm.isEdit } },
                          [
                            _c("WorkingHours", {
                              ref: "noisyWorkingHours",
                              attrs: {
                                hideLabel: true,
                                disabled: !_vm.isEdit,
                                isMandatory: _vm.noisyWorkingHoursChecked,
                                workingHours:
                                  _vm.currentWorkPermit.noisyWorkingHours || [],
                                updateValueByPath: _vm.updateFieldByPath,
                                fieldPath: ["noisyWorkingHours"],
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.noisyWorkingHoursChecked
                ? _c(
                    "div",
                    { staticClass: "generalInfo_noisyWorkingHours" },
                    [
                      _c("label", { staticClass: "bold" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("workPermit.noisyWorkingHoursRemarks")
                            ) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.isEdit
                        ? _c("HKLTextarea", {
                            staticClass: "small-12 medium-6 large-6",
                            attrs: {
                              value:
                                _vm.currentWorkPermit.noisyWorkingHoursRemarks,
                            },
                            on: {
                              onChange: function (value) {
                                return _vm.updateField(
                                  "noisyWorkingHoursRemarks",
                                  value
                                )
                              },
                            },
                          })
                        : _c("HKLText", {
                            attrs: {
                              text:
                                _vm.currentWorkPermit
                                  .noisyWorkingHoursRemarks ||
                                _vm.$t("emptyValue"),
                            },
                          }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("HKLQRCode", {
            staticClass: "work-permit-qr-code",
            class: { "qr-margin-top": _vm.hasBtnOnTop },
            attrs: {
              text: _vm.qrCodeUrl,
              hint: _vm.$t("hint.readQRHint", [_vm.qrCodeUrl]),
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "generalInfo_attachment",
          class: { "error-highlight": !_vm.validAttachmentDoc },
        },
        [
          _c(
            "p",
            {
              class: [
                "bold",
                { "required-flag": _vm.isAttachmentMandatory && _vm.isEdit },
              ],
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("workPermit.attachment")) + "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _vm.isEdit && _vm.attachmentHint
            ? _c("i", { staticClass: "gray_font" }, [
                _vm._v("\n      " + _vm._s(_vm.attachmentHint) + "\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          (_vm.isEdit && _vm.canExternalUpload) || _vm.canUploadUnderAppr
            ? _c("HkldDropzone", {
                attrs: { sourceId: _vm.sourceId, metaData: _vm.metaData },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("EditAttachments", {
            attrs: {
              sourceId: _vm.sourceId,
              canDelete:
                (_vm.isEdit && _vm.canExternalUpload) || _vm.canUploadUnderAppr,
              canDownloadAll: false,
              canEdit: _vm.isEdit && _vm.canExternalUpload,
              showEditPencil: _vm.showEditPencilFunc,
              showAllDeleteBtn: false,
              showDeleteBtnFunc: _vm.showDeleteBtnFunc,
              getFilesList: _vm.getFilesList,
            },
          }),
          _vm._v(" "),
          !_vm.isEdit && !_vm.filesLength
            ? _c("div", [_vm._v("\n      --\n    ")])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("TimePickerModal", {
        ref: "extendWorkPermitModal",
        attrs: {
          disabledDateTimes: _vm.extendDisabledDate,
          extendButton: _vm.$t("action.extend"),
        },
        on: {
          cancelEvent: _vm.cancelExtend,
          extendEvent: _vm.checkInsuranceDateThenHKLDExtendWorkpermit,
        },
        model: {
          value: _vm.extendDate,
          callback: function ($$v) {
            _vm.extendDate = $$v
          },
          expression: "extendDate",
        },
      }),
      _vm._v(" "),
      _c("TimePickerModal", {
        ref: "requestExtendWorkPermitModal",
        attrs: {
          disabledDateTimes: _vm.extendDisabledDate,
          extendButton: _vm.$t("action.request"),
        },
        on: {
          cancelEvent: _vm.cancelRequestExtend,
          extendEvent: _vm.checkInsuranceDateThenRequestExtension,
        },
        model: {
          value: _vm.requestExtendDate,
          callback: function ($$v) {
            _vm.requestExtendDate = $$v
          },
          expression: "requestExtendDate",
        },
      }),
      _vm._v(" "),
      _c("TimePickerModal", {
        ref: "confirmExtendWorkPermitModal",
        attrs: {
          disabledDateTimes: _vm.extendDisabledDate,
          extendButton: _vm.$t("action.confirm"),
          extendHint: _vm.$t("workPermit.extendConfirmHint"),
        },
        on: {
          cancelEvent: _vm.cancelConfirmExtend,
          extendEvent: _vm.checkInsuranceDateThenConfirmExtension,
        },
        model: {
          value: _vm.confirmExtendDate,
          callback: function ($$v) {
            _vm.confirmExtendDate = $$v
          },
          expression: "confirmExtendDate",
        },
      }),
      _vm._v(" "),
      _c("InsuranceNotCoverModal", {
        ref: "insuranceNotCoverModal",
        attrs: { hint: _vm.insuranceNotCoverHint },
        on: {
          cancelEvent: _vm.clickInsuranceCancel,
          continueEvent: _vm.clickInsuranceContinue,
        },
      }),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "suspendWorkPermitModal",
          staticClass: "suspend__work-permit",
          attrs: { showCloseBtn: false, modalId: "suspend-wp-" + +new Date() },
        },
        [
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _c(
                "div",
                { staticClass: "suspend-permit__remarks" },
                [
                  _c("TextField", {
                    staticClass: "workpermit-content-slot__review-text-input",
                    attrs: {
                      label: _vm.$t("workPermit.remarks"),
                      showColon: false,
                      value: _vm.suspendComments,
                    },
                    on: {
                      updateValue: function (val) {
                        return (_vm.suspendComments = val)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "suspend-permit__dropzone" },
                [
                  _c("p", { staticClass: "suspend-permit-hint" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("workPermit.suspendDocHint")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("HkldDropzone", {
                    ref: "suspendDropzone",
                    attrs: {
                      sourceId: _vm.randomId,
                      maxNumberOfFiles: 20,
                      autoProcess: false,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("EditAttachments", {
                ref: "suspendAttachment",
                staticClass: "suspend-file_container",
                attrs: {
                  sourceId: _vm.randomId,
                  getFilesList: _vm.getSuspendFileList,
                  initLoading: false,
                  isShowDes: false,
                  canEdit: false,
                  isShowUploadedDate: false,
                  canDelete: true,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.openCancelSuspendConfirmModal()
                  },
                },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("action.cancel")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.suspendPermit()
                  },
                },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("action.suspend")) + "\n      "
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "resumeWorkPermitModal",
          attrs: { modalId: "resume-wp-" + +new Date() },
        },
        [
          _c("p", { staticClass: "font-bold" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("workPermit.resumeHint")) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.closeResume()
                  },
                },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("action.cancel")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.resumePermit()
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("action.yes")) + "\n      ")]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "WorkPermNextReviewerModal",
        {
          ref: "reAssign_nextReivewerModal_" + _vm.currentWorkPermit.id,
          attrs: {
            modalId:
              "reAssign_nextReivewerModal_" +
              _vm.currentWorkPermit.id +
              "-" +
              +new Date(),
            excludeCurrent: true,
          },
          on: { "multi-select-submited": _vm.reAssignReviewer },
        },
        [
          _c(
            "div",
            {
              attrs: { slot: "wp-next-reviewer-content" },
              slot: "wp-next-reviewer-content",
            },
            [
              _c("p", { staticClass: "emphasis" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("workPermit.reAssign")) +
                    "\n      "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("ReassignHistories", {
            attrs: { slot: "additional-content" },
            slot: "additional-content",
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "cancelSuspendConfrimModal",
        attrs: {
          confirmTitle: _vm.$t("workPermit.removeDocsHint"),
          modalId: "cancel-suspend-" + +new Date(),
        },
      }),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "extensionConflictModal",
        attrs: {
          modalId: "extension-conflict-" + +new Date(),
          confirmTitle: _vm.$t("standaloneWorkPermit.conflictWithSWP"),
        },
      }),
      _vm._v(" "),
      _c("RejectExtensionModal", { ref: "rejectExtensionModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }